// extracted by mini-css-extract-plugin
export default {"mySwiper1":"slider_mySwiper1__2O-eG","contentContainer":"slider_contentContainer__jSDCx"};